import axios, { CancelToken } from 'axios';
import qs from 'qs';
import { Branding } from '@/features/branding/branding.dto';
import { ApiResult, Filter, ServiceResponse } from '@/OptimusRoutes/interfaces';

interface IBranding {
	getBrandForLogin: (source?: CancelToken) => Promise<ServiceResponse<Branding>>;
	getList: (filter: Filter<Branding>) => Promise<ServiceResponse<ApiResult<Branding>>>;
	deleteById: (id: number) => Promise<ServiceResponse>;
	create: (branding: Partial<Branding>) => Promise<ServiceResponse<Branding>>;
	updateById: (id: number, branding: Partial<Branding>) => Promise<ServiceResponse<Branding>>;
}

class Service implements IBranding {
	async create(branding: Partial<Branding>): Promise<ServiceResponse<Branding>> {
		const { data } = await axios.post<ServiceResponse<Branding>>('/v2/branding', branding);
		return data;
	}

	async updateById(id: number, branding: Partial<Branding>): Promise<ServiceResponse<Branding>> {
		const { data } = await axios.patch<ServiceResponse<Branding>>(`/v2/branding/${id}`, branding);
		return data;
	}

	async getBrandForLogin(cancelToken?: CancelToken): Promise<ServiceResponse<Branding>> {
		const response = await axios.get<ServiceResponse<Branding>>('/v2/branding', { cancelToken });
		return response.data;
	}

	async getList({ filter = {}, skip, take }: Filter<Branding>): Promise<ServiceResponse<ApiResult<Branding>>> {
		const params = { filter: JSON.stringify(filter), skip, take };
		const { data } = await axios.get<ServiceResponse<ApiResult<Branding>>>(
			`/v2/branding/list?${qs.stringify(params)}`
		);
		return data;
	}

	async deleteById(id: number): Promise<ServiceResponse> {
		const { data } = await axios.delete<ServiceResponse>(`/v2/branding/${id}`);
		return data;
	}
}

const BrandingService = new Service();

export default BrandingService;
